export function openInNewTab(url: string) {
  return window.open(url, '_blank');
}

export function isInIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return false;
  }
}
